import React from "react"
import { connect } from "react-redux"

import { filterProductOptionsV2 } from "helpers/product/product-filtering"

export default function withProductAddons(WrappedComponent) {
  const InternalWithProductAddons = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = (state) => {
    const choices = state.choices || {}
    const addons = state.wizard.addons
      ? filterProductOptionsV2(
          state.wizard.addons.filter((addon) => addon.in_stock),
          choices,
          true
        )
      : []
    const selectedAddons = state.choices.addon ? state.choices.addon.value : []

    const productPrice = state.wizardUI.currentPricing.price_to_display
    const boxPrice =
      state.choices.box && state.choices.box.price ? state.choices.box.price : 0
    const addonPrice = addons
      .filter((addon) => selectedAddons.includes(addon.set_key))
      .reduce((sum, addon) => (sum += addon.surcharge), 0)
    const totalItemPrice = productPrice + boxPrice + addonPrice

    return {
      addons,
      selectedAddons,
      totalItemPrice,
    }
  }

  const WithProductAddons = connect(mapStateToProps)(InternalWithProductAddons)

  return WithProductAddons
}
